module.exports = __webpack_public_path__ + "static/media/delete.79eabf65.svg";